import { useState } from 'react';
import PaginatedVehicleList from './PaginatedVehicleList';
import SearchBar from 'components/SearchBar/SearchBar';

export default function MyVehiclesList() {
  const [searchText, setSearchText] = useState('');

  return (
    <>
      <SearchBar label="Search a vehicle..." value={searchText} setQuery={setSearchText} />
      <PaginatedVehicleList filterByCurrentUser searchText={searchText} />
    </>
  );
}
